export const ImportSystems = {
    Vista: 1,
    HeavyBid: 2,
    ArcGisOnline: 3,
};
